import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProps } from 'src/shared/prop-types/ReducerProps';


const ReactTableDefaultBody = ({ page, getTableBodyProps, prepareRow, onRowClick }) => (
  <tbody className="react-table-body" {...getTableBodyProps()}>
    {page.map((row, index) => {
      if (!row.original || Object.keys(row.original).length === 0) return null;
      prepareRow(row);
      const rowProps = row.getRowProps();
      const rowClass = index % 2 === 0 ? 'evenRow' : 'oddRow';
      return (
        <tr
          {...rowProps}
          className={`highlight tableHover ${rowClass}`}
          onClick={() => onRowClick && onRowClick(row)}
          style={{ ...rowProps.style, cursor: onRowClick ? 'pointer' : 'default' }}
        >
          {row.cells.map(cell => {
            const cellProps = cell.getCellProps() || {};
            const isFlexLayout = cellProps.style?.display === 'flex';
            return (
              <td
                {...cellProps}
                style={{
                  ...cellProps.style,
                  textAlign: cell.column.align || 'left',
                  padding: '12px 16px',
                  fontSize: '13px',
                  color: '#334155',
                  borderBottom: '1px solid #f1f5f9',
                  verticalAlign: 'middle',
                  fontWeight: 500,
                  display: isFlexLayout ? 'flex' : 'table-cell',
                  alignItems: 'center',
                  justifyContent: cell.column.align === 'right' ? 'flex-end' : cell.column.align === 'center' ? 'center' : 'flex-start',
                  ...(cell.column.width ? { width: cell.column.width } : {}),
                }}
              >
                {cell.render('Cell')}
              </td>
            );
          })}
        </tr>
      );
    })}
  </tbody>
);

ReactTableDefaultBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
};

const ReactTableBody = ({
  page, getTableBodyProps, prepareRow, onRowClick
}) => (
  <Fragment>

    <ReactTableDefaultBody
      page={page}
      getTableBodyProps={getTableBodyProps}
      prepareRow={prepareRow}
      onRowClick={onRowClick}
    />

  </Fragment>
);

ReactTableBody.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  updateDraggableData: PropTypes.func.isRequired,
  withDragAndDrop: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
};

export default connect(state => ({
  theme: state.theme,
}))(ReactTableBody);
